import { BaseService } from "./base.service";
import { IDocumentType } from "models/DocumentTypeModel";

class DocumentTypeServiceInternal extends BaseService {
	getDocumentTypeList = async (moduleId?: number): Promise<IDocumentType[]> =>
		this.callApi<IDocumentType[]>(
			`DocumentType/GetDocumentTypeList`,
			"GET",
			new URLSearchParams({
				moduleId: moduleId ? moduleId.toString() : "",
			})
		);
}

export const DocumentTypeService = new DocumentTypeServiceInternal();
